import React, { useEffect, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Button from 'components/Button';
import { useNavigate } from 'react-router-dom';
import CloseIcon from 'assets/images/CloseIcon.png';
// import { getGenToken } from 'redux/actions/profile'
import { certificateListPTMS ,getGenToken } from "redux/actions/manageAccount";
import { Modal,ModalBody, ModalFooter } from 'reactstrap';
import './genCertModal.css';

const GetCetModal = ({ isOpen, toggle, title, selectedState, content, link,id, onClickHander, getCetType, callBack }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const token = loggedInUserInfo?.token

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchMyAPI()
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const fetchMyAPI = useCallback(async () => {
    if (token === null) {
    } else {
      let response = await dispatch(certificateListPTMS(token, id));
      genCetFun(response.response.token)
      if (response.status === 'SUCCESS') {       
        
      } else {
        if (response.message === "Unauthorized (Invalid token)") {
          navigate('/')
        } else {

        }
      }
    }
  }, []);
  const genCetFun = (token) => {
    window.GenCert.init(document.getElementById("form_container"), {
      ship_zone: selectedState,
      token: token,
      edit_purchaser: true,
      onCertSuccess: function (e) {
        callBack()
      },
      onCancel: function (e) {
        callBack()
      },
      onManualSubmit: function (e) {
      },
      afterShow: function (e) {
      },
      onCertFailure: function (e) {
      },
      onNotNeeded: function (e) {
      },
      onSaveCustomer: function (e) {
      },
    });
    window.GenCert.show();
  }
  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='genCert-modal'>
        <div className='modal-content'>
          <div className='header'>
            <div style={{"background": "transparent","padding": "10px","height": "42px","cursor": "pointer"}}>
            <Button handleClick={() => {
              toggle(!isOpen)
              onClickHander()
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" style={{"width": "22px"}} />
            </Button>
            </div>
            <h3></h3>
          </div>
          <ModalBody>
            <div>
              <h3 className='modal-title'>{title}</h3>
            </div>
            <div>
              <div id="form_container"></div>
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};

export default GetCetModal;